import { makeStyles } from "tss-react/mui";
import { ITenantHolidayResponse } from "@miplatform/types";
import { Box, Tooltip, Typography } from "@mui/material";
import { IDisabledSlot } from "../PrioritySchedulerBoard.types";

export interface DisabledSlotsProps {
  disabledSlots?: IDisabledSlot[];
  holiday?: ITenantHolidayResponse;
  hourHeight: number;
}

export function DisabledSlots({
  disabledSlots = [],
  holiday,
  hourHeight,
}: Readonly<DisabledSlotsProps>) {
  const { classes } = useStyles();

  if (holiday) {
    return (
      <Box
        style={{
          top: 0,
          height: 24 * hourHeight - 8,
        }}
        className={classes.disabledSlot}
      >
        {holiday.name && (
          <Typography className={classes.disabledText}>
            {holiday.name}
          </Typography>
        )}
      </Box>
    );
  }

  return (
    <>
      {disabledSlots.map((slot) => {
        const startDecimal = slot.start.hours() + slot.start.minutes() / 60;
        const endDecimal = slot.end.hours() + slot.end.minutes() / 60;
        const top = startDecimal * hourHeight;
        const height = (endDecimal - startDecimal) * hourHeight - 8;

        return (
          <Tooltip key={slot.id} title={slot.note ?? ""}>
            <Box
              style={{ top, height, zIndex: 3 }}
              className={classes.disabledSlot}
            >
              {slot.note && (
                <Typography className={classes.disabledText}>
                  {slot.note}
                </Typography>
              )}
            </Box>
          </Tooltip>
        );
      })}
    </>
  );
}

const useStyles = makeStyles()((theme) => ({
  disabledSlot: {
    position: "absolute",
    left: 0,
    right: 0,
    backgroundColor: `${theme.palette.grey.dark}14`,
    display: "flex",
    justifyContent: "center",
    padding: theme.spacing(2, 1.5),
    borderRadius: theme.spacing(0.5),
    border: `1px solid ${theme.palette.grey.medium}`,
    margin: theme.spacing(1),
    overflow: "hidden",
    backgroundImage: `repeating-linear-gradient(
    -160deg, 
    transparent, 
    transparent 30px, 
    ${theme.palette.grey.dark}10 30px, 
    ${theme.palette.grey.dark}10 40px
  )`,
  },
  disabledText: {
    color: theme.palette.grey.medium,
    fontSize: theme.fontSize.small,
    fontWeight: theme.fontWeight.semiBold,
  },
}));
